// Home.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import Footer from '../components/Footer2';
import Navbar from '../components/Navbar';
import Video from '../components/Video';
import Banner from '../components/Banner';
import MultiItemCarousel from '../components/partners/MultiItemCarousel';
import HeroImage2 from '../components/HeroImage2';
import Recap from '../components/Recap';



const Home = () => {
    return (
        <div>
            <Navbar />
            <Video />
            <Recap />
            {/* Pass the link as a prop */}
            <HeroImage2 
                heading='This December!' 
                text='Find out more about where to find us in your province.' 
                link={<Link to='/contact' className='btn-sponsor'>More</Link>} // Pass the Link component here
            />
            <Banner />
            <MultiItemCarousel />
            <Footer />
        </div>
    );
};

export default Home;
